export default "__VITE_ASSET__Clv5mCD1__"